const Form = ({ children, ref }) => {
    return (
        <form ref={ref}>
            <div className="main-content__add-form">
                <div className="main-content__form">
                    {children}
                </div>
            </div>
        </form>
    );
};

export default Form;
